module.exports = __webpack_public_path__ + "img/acuerdoCapte04.0d0588a2.jpg";